import { IESGDetails } from '@Domains/Progress';
import ProgressBarLayout from '@Router/Landing/Components/ProgressBar/ProgressBarLayout';
import { getStatusFromProgress } from '@Router/Landing/Containers/utils';

const GreenhouseSection = ({
  esg,
  reportId,
  isPublished,
}: {
  esg: IESGDetails;
  reportId?: number;
  isPublished: boolean;
}) => (
  <ProgressBarLayout
    path="esg-plans/greenhouse"
    status={getStatusFromProgress(esg.greenhouse?.completionPercentage || 0)}
    title="เปิดเผยข้อมูลเกี่ยวข้องกับการปล่อยก๊าซเรือนกระจก"
    progress={esg?.greenhouse?.completionPercentage ?? 0}
    id={reportId}
    isPublished={isPublished}
  />
);

export default GreenhouseSection;
